export default {
  getSearchedUsers: state => Object.values(state.searchedUsers),
  getExtraUsers: state => Object.values(state.extraUsers),
  getFavoriteUsers: state => Object.values(state.favoriteUsers),
  getBlockedUsers: state => Object.values(state.blockedUsers),
  getOnlineUsers: state => state.onlineUsers,
  getSelectedUser: state => state.selectedUser,
  hasErrorResult: state => state.searchErrorResult,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js